<template>
    <div>
        <form-group label="Type" name="type" :required="true">
            <div class="select">
                <select v-model="expense.type" id="type" class="input">
                    <option :value="null" disabled>Select an expense type</option>
                    <option v-for="(type, slug) in sortedExpenseTypes" :value="type.id">
                        {{type.name}}
                    </option>
                </select>
            </div>
        </form-group>

        <keep-alive>
            <component :is="formType"
                       v-model="expense"
                       :expenseType="selectedExpenseType"
                       :fileUploadUrl="fileUploadUrl"
                       :fileDeleteUrl="fileDeleteUrl"
                       @activeFileUpload="activeFileUpload"/>
        </keep-alive>

        <form-group label="Comment" name="comment" v-if="!expense.hasOwnProperty('id')">
            <textarea class="input" id="comment" rows="5" v-model="expense.comment"></textarea>
        </form-group>
    </div>
</template>

<script>
    import NeedsExpenseFormTypes from "@/mixins/NeedsExpenseFormTypes";
    import MonetaryForm from "@/partials/expenses/edit/MonetaryForm";
    import MileageForm from "@/partials/expenses/edit/MileageForm";
    import PerDiemForm from "@/partials/expenses/edit/PerDiemForm";
    import TimeAllowanceForm from "@/partials/expenses/edit/TimeAllowanceForm";

    export default {
        mixins: [NeedsExpenseFormTypes],

        components: {
            MonetaryForm,
            MileageForm,
            PerDiemForm,
            TimeAllowanceForm,
        },

        props: ['value'],

        data() {
            return {
                expense: {...this.value},
                expenseTypes: [],
            }
        },

        methods: {
            activeFileUpload(value) {
                this.$emit('activeFileUpload', value);
            },
        },

        computed: {
            formType() {
                let formType = this.formTypes.find(e => e.id === this.expense.type);
                return formType && `${formType.form}Form`;
            },

            fileUploadUrl() {
                let url = this.$api().getUrl('expenses/attachments');

                if (this.expense.id) {
                    url += `/${this.value.id}`;
                }

                return url;
            },

            fileDeleteUrl() {
                return this.$api().getUrl('expenses/attachments');
            },

            sortedExpenseTypes() {
                return _.sortBy(this.expenseTypes, function (type) {
                    return type.name;
                });
            },

            selectedExpenseType() {
                const a = this.expenseTypes.find(i => i.id === this.expense.type);

                if (a) {
                    return a.name;
                }
            }
        },

        mounted() {
            this.$api('expenses').get('create')
                .then(({data}) => {
                    this.expenseTypes = data.types;
                });
        },

        watch: {
            expense: {
                deep: true,
                handler(val) {
                    this.$emit('input', val);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>
